// packages/api-client/queries/contestsEditionsStageTables/index.ts
import { useQuery, useMutation, } from "@tanstack/react-query";
export const createContestsEditionsStageTablesQueries = (requests, queryClient) => ({
    useCreateContestsEditionStageTable: (options = {}) => useMutation({
        ...options,
        mutationFn: (contestsEditionsStageTableAttrs) => {
            return requests.createContestsEditionStageTable(contestsEditionsStageTableAttrs);
        },
        onSuccess: (...args) => {
            queryClient.invalidateQueries({
                queryKey: ["contests-editions-stages"],
            });
            queryClient.invalidateQueries({
                queryKey: ["contests-editions-stage-tables"],
            });
            options.onSuccess?.(...args);
        },
    }),
    useDeleteContestsEditionsStageTable: (options = {}) => useMutation({
        ...options,
        mutationFn: (contestsEditionsStageTableId) => {
            return requests.deleteContestsEditionStageTable(contestsEditionsStageTableId);
        },
        onSuccess: (...args) => {
            queryClient.invalidateQueries({
                queryKey: ["contests-editions-stage-tables"],
            });
            options.onSuccess?.(...args);
        },
    }),
    useListContestsEditionStageTables: (params, options = {}) => useQuery({
        queryKey: ["contests-editions-stage-tables", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.listContestsEditionStageTables(params);
        },
        ...options,
    }),
    useUpdateContestsEditionStageTable: (options = {}) => useMutation({
        ...options,
        mutationFn: (contestsEditionsStageTableAttrs) => {
            return requests.updateContestsEditionStageTable(contestsEditionsStageTableAttrs);
        },
        onSuccess: (...args) => {
            queryClient.invalidateQueries({
                queryKey: ["contests-editions-stages"],
            });
            queryClient.invalidateQueries({
                queryKey: ["contests-editions-stage-tables"],
            });
            options.onSuccess?.(...args);
        },
    }),
});
//# sourceMappingURL=index.js.map